function getCookie(name: string): string | null {
    const cookies = document.cookie.split(';')
    for (const cookie of cookies) {
        const [key, value] = cookie.trim().split('=')
        if (key === name) return decodeURIComponent(value)
    }
    return null
}

class ApiClient {
    private getHeaders(): HeadersInit {
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
        }

        const csrf = getCookie('csrftoken')
        if (csrf) headers['X-CSRFToken'] = csrf

        return headers
    }

    private async handleResponse<T>(response: Response): Promise<T> {
        if (response.status === 204) return null as T
        return response.json()
    }

    async get<T>(path: string): Promise<T> {
        const res = await fetch(path, {
            headers: this.getHeaders(),
        })
        return this.handleResponse<T>(res)
    }

    async post<T>(path: string, body?: unknown): Promise<T> {
        const res = await fetch(path, {
            method: 'POST',
            headers: this.getHeaders(),
            body: body ? JSON.stringify(body) : undefined,
        })
        return this.handleResponse<T>(res)
    }
}

export const api = new ApiClient()
